<!-- analisis-periodos.component.html -->
<div class="analisis-periodos-container">
  <div class="table-container">
    <table mat-table [dataSource]="dataSource1Activo" class="mat-elevation-z2 full-width-table">
       <ng-container matColumnDef="CAnalizados">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let row">
        <table class="valor-info data-table"> 
          <tr class="header-row">
            <td>
              Período: {{row.contadorAnalizados}}
              <button mat-icon-button class="ir-grafica-btn" type="button"
                      matTooltip="Ver este período en la gráfica (con zoom)"
                      (click)="verEnGrafica(row)">
                <mat-icon>zoom_in</mat-icon>
              </button>
            </td>
            <td>{{row.fechaInicio}}</td>
            <td>{{row.fechaFin}}</td>
            <td class="percent-column">%</td>
          </tr>
          <tr>
            <td>Vol Historica</td>
            <td>{{row.vHistoricoI| number:'1.2-2'}}</td>
            <td>{{row.vHistoricoF| number:'1.2-2'}}</td>
            <td class="percent-column">{{row.vHistorico| number:'1.2-2'}}</td>
          </tr> 
          <tr>
            <td>Vol Relativa</td>
            <td>{{row.vRelativaI| number:'1.2-2'}}</td>
            <td>{{row.vRelativaF| number:'1.2-2'}}</td>
            <td class="percent-column">{{row.vRelativa| number:'1.2-2'}}</td>
          </tr> 
          <tr>
            <td>Desv estandar</td>
            <td>{{row.desviacionStandardI| number:'1.2-2'}}</td>
            <td>{{row.desviacionStandardF| number:'1.2-2'}}</td>
            <td class="percent-column">{{row.desviacionStandard| number:'1.2-2'}}</td>
          </tr> 
          <tr><td>Vol. Mercado</td><td>{{row.valorVolatilidadFI}}</td><td>{{row.valorVolatilidadFF}}</td><td></td></tr>
          <tr><td>Valores</td><td>{{row.valorFinFI}}</td><td>{{row.valorFinFF}}</td><td></td></tr>
          <tr><td>Rango Fin</td><td></td><td></td><td>{{row.periodosRangoMayorFin}}{{row.periodosRangoMenorFin}}</td></tr>
        </table>
      </td>
    </ng-container>
    <!-- Columna Nombre -->
    <ng-container matColumnDef="valores">
      <th mat-header-cell *matHeaderCellDef>Valores</th>
      <td mat-cell *matCellDef="let row">
          <table class="valor-info data-table"> 
            <tr class="header-row"><td>Inicial</td><td>Final</td></tr>
            <tr><td>{{row.valorFinFI}}</td><td>{{row.valorFinFF}}</td></tr>
          </table>
      </td>
    </ng-container>
      <!-- Columna Períodos Analizados -->
       <ng-container matColumnDef="PAnalizados">
      <th mat-header-cell *matHeaderCellDef>Períodos</th>
      <td mat-cell *matCellDef="let row">
        {{row.PAnalizados}}
      </td>
    </ng-container>

      <!-- Columna Períodos Cumplen Volatilidad -->
      <ng-container matColumnDef="PRangosVolatilidad">
        <th mat-header-cell *matHeaderCellDef class="sticky-header">
          P. Rango Volatilidad
        </th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          <table class="valor-info data-table"> 
            <tr class="header-row"><td>Inicial</td><td>Final</td></tr>
            <tr><td>{{row.valorVolatilidadFI}}</td><td>{{row.valorVolatilidadFF}}</td></tr>
          </table>
        </td>
      </ng-container>

      <!-- Columna Rango Mayor -->
      <ng-container matColumnDef="periodosrangoMayor">
        <th mat-header-cell *matHeaderCellDef class="sticky-header">
          Dia Rango Mayor
        </th>
        <td mat-cell *matCellDef="let row" class="table-cell">
          <table class="valor-info data-table"> 
            <tr class="header-row"><td>Fecha</td><td>Valor</td><td>%</td></tr>
            <tr><td>{{row.fechaVariacionMayor  | date:'dd/MM/yyyy'}}</td><td>{{row.valorFinFechaVariacionMayor}}</td><td>{{row.variacionMayor | number:'1.2-2'}} %</td></tr>  
          </table>
        </td>
      </ng-container>

      <!-- Columna Rango Menor -->
      <ng-container matColumnDef="periodosRangoMenor">
        <th mat-header-cell *matHeaderCellDef class="sticky-header">
          Dia Rango Menor
        </th>
        <td mat-cell *matCellDef="let row" class="table-cell">
        
        <table class="valor-info data-table"> 
          <tr class="header-row"><td>Fecha</td><td>Valor</td><td>%</td></tr>
          <tr><td>{{row.fechaVariacionMenor  | date:'dd/MM/yyyy'}}</td><td>{{row.valorFinFechaVariacionMenor}}</td><td>{{row.variacionMenor | number:'1.2-2'}} %</td></tr>
        </table>
        </td>
      </ng-container>

      <!-- Columna Rango Mayor Fin -->
      <ng-container matColumnDef="periodosRangoMayorFin">
        <th mat-header-cell *matHeaderCellDef class="sticky-header">
          Rango Fin Mayor
        </th>
        <td mat-cell *matCellDef="let element" class="table-cell">
          <div class="valor-info">
          {{element.periodosRangoMayorFin}}
          </div>
        </td>
      </ng-container>

      <!-- Columna Rango Menor Fin -->
      <ng-container matColumnDef="periodosRangoMenorFin">
        <th mat-header-cell *matHeaderCellDef="let element" class="sticky-header">
          Rango Fin Menor
        </th>
        <td mat-cell *matCellDef="let element" class="table-cell">
          <div class="valor-info">{{element.periodosRangoMenorFin}}</div>
        </td>
      </ng-container>

      <!-- Definir header y rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>